module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "element-btn",
    on: {
      "click": function($event) {
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        return _vm.buttonClicked($event)
      }
    }
  }, [_c('div', {
    attrs: {
      "title": (_vm.element.width == 10 ? _vm.text : '')
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "24px"
    },
    attrs: {
      "color": (_vm.element.complete || _vm.complete ? 'primary' : 'grey')
    }
  }, [_vm._v(_vm._s(_vm.icon || 'category'))])], 1), _vm._v(" "), (_vm.element.width != 10) ? _c('div', {
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.text || _vm.element.title) + "\n    ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7273a082"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ElementButton.vue
// module id = 2600
// module chunks = 1